// appVersion: 4.1.1
import Vue from 'vue'
import App from './App.vue'

// === Import Plugin ===
import '@/plugin/dateFns'
import '@/plugin/vue-lazyload'
import '@/plugin/element-ui'
import '@/plugin/registerServiceWorker'
import '@/plugin/vue-lang'
import '@/plugin/vue-utilities' // Global functions
import '@/plugin/global-variable' // Global variable

// === Import Style ===
import '@/assets/element-variables.scss'
import '@/assets/global-style.scss'
import '@/assets/components.scss'

import router from '@/router'
import store from './store/store'
import firebase from 'firebase/app';
import 'firebase/auth';
import { ensureReportAuth } from '@/store/core/reportAuth'

var configFirebase = {
  apiKey:'AIzaSyAE_lkz0jofbcDev5TrQI5FzevgWi8-VQA',
  authDomain: 'people2-admin.firebaseapp.com',
  databaseURL: 'https://people2-admin.firebaseio.com/',
  storageBucket: 'people2-admin.appspot.com',
  projectId: 'people2-admin',
  messagingSenderId: '561345191871'
}

firebase.initializeApp(configFirebase)
Vue.config.productionTip = false

// Report pages authenticate with the token already in the URL — start the
// Cloud-Function exchange during boot so it overlaps chunk load and Vue
// mount instead of waiting for the page component's first data fetch.
// Rejects harmlessly on non-report routes (no token in the URL).
ensureReportAuth().catch(() => {})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
